const BACKEND_API = process.env.VUE_APP_ROOT_API


const DOWNLOAD_DOCUMENT = {
    BATCH_DOC: '/document/result/download-batch/{type}',
    BATCH_DOC_IN_TAG: '/document/result/download-in-tag/{tagId}/{type}',
    DOC: '/document/result/{slug}/download/{type}',
    REPORT: '/document/result/{slug}/generateReport',
    HIGHLIGHT: '',
}

const DOWNLOAD_GROUP_DOCUMENT = {
    BATCH_DOC: '/group-document/result/download-batch/{type}',
    BATCH_DOC_IN_GROUP: '/group-document/result/download-in-group/{groupId}/{type}',
    DOC: '/group-document/result/{slug}/download/{type}',
    REPORT: '/group-document/result/{slug}/generateReport',
    HIGHLIGHT: '',
}


const DELETE_DOCUMENT = {
    SOFT_DELETE: '/document/delete/{slug}',
    FORCE_DELETE: '/document/force-delete/{slug}'
}

const DELETE_GROUP = {
    FORCE_DELETE: '/group/delete/{id}'
}


const DOCUMENT = {
    GET_DOCUMENT_ALL: '/document',
    GET_DOCUMENT_INFO: '/document/{slug}/info',
    PUT_DOCUMENT: '/document',
    POST_DOCUMENT: '/document/update/{slug}',
    CHECK_DOCUMENT: '/document/check/{slug}',
    POST_SIMILARITY_RESULTS_IGNORED_BY_USER: '/document/result/{slug}/similarity_ignored_by_user',
    SHARE_GRANT: '/document/share/grant',
    SHARE_DENY: '/document/share/deny',
    GET_ALL_DOCUMENT_BY_TAG: '/document/tag/{id}',
    GET_SUMMARY_RESULT: '/document/summary-result/{slug}',
    GET_DOCUMENT_STATISTIC: '/user/document-statistic',
    RESET_READ_ACTION: '/document/reset-action/{slug}',
    MARK_AS_READ: '/document/mark-as-read/{slug}'
}

const GROUP_DOCUMENT = {
    GET_ALL_DOCUMENT_BY_GROUP: '/group-document/group/{id}',
    GET_DOCUMENT_INFO: '/group-document/{slug}/info',
    POST_DOCUMENT: '/group-document/update/{slug}',
    GET_LIST_DOCUMENTS_INFO: '/group-document/list-info',
    GET_SUMMARY_RESULT: '/group-document/summary-result/{slug}'
}

const DOCUMENT_VERSION = {
    GET_LATEST_VERSION: '/document/version/{slug}/latest',
    GET_VERSION: '/document/version/{slug}/{version}',
    GET_ALL_VERSION: '/document/version/{slug}'
}

const GROUP_DOCUMENT_VERSION = {
    GET_LATEST_VERSION: '/group-document/version/{slug}/latest',
    GET_VERSION: '/group-document/version/{slug}/{version}',
    GET_ALL_VERSION: '/group-document/version/{slug}'
}

const ADMIN_DASHBOARD = {
    GET_DOCUMENT_ALL: '/admin/document/list',
    GET_STATISTIC: '/admin/statistic',
    GET_TRIVIAL_SENTENCE: '/admin/trivial-sentence/list',
    GET_TRIVIAL_CANDIDATE_SENTENCE: '/admin/trivial-candidate-sentence/list',
    CONFIRM_TRIVIAL_CANDIDATE_SENTENCE: '/admin/trivial-candidate-sentence/confirm',
    IGNORE_TRIVIAL_CANDIDATE_SENTENCE: '/admin/trivial-candidate-sentence/ignore',
    DELETE_TRIVIAL_SENTENCE: '/admin/trivial-sentence/delete/{id}',
    PUT_TRIVIAL_SENTENCES: '/admin/trivial-sentence/put',
    GET_PRICING_PLAN: '/admin/pricing-plan/list',
    UPLOAD_BLACKLIST: '/admin/setting/blacklist',
    GET_BLACKLIST: '/admin/setting/blacklist'
}

const SYSTEM_CONFIG = {
    GET_SETTING_ALL: '/system/setting/all',
    GET_MAIL_HISTORY_ALL: '/system/mail_history/all',
    UPDATE_SETTING: '/system/setting/update/{key}',
    GET_STATISTIC: '/root/statistic'
}

const DOIT_CONFIG = {
    GET_DOCUMENT_CONFIG: '/document/score/level'
}
const USER_AUTH = {
    REGISTER: BACKEND_API + '/user/register',
    LOGOUT: BACKEND_API + '/logout',
    LOGIN: BACKEND_API + '/login',
    CONFIRM_REGISTRATION: BACKEND_API + '/user/confirm_registration',
    RESEND_CONFIRM_REGISTRATION: BACKEND_API + '/user/resend_registration_email',
    CREATE: '/admin/user/create',
    CHECK_EMAIL_EXISTENCE: '/user/isExistEmail',
    GOOGLE_VERIFY_TOKEN: BACKEND_API + '/auth/google'
}

const USER_INFO = {
    GET_INFO: '/user/info',
    GET_PERMISSION: '/user/permission',
    GET_RECENT_CREDIT_USAGE: '/user/outgoing-credit'
}

const USER_PROFILE = {
    GET: '/user/profile',
    UPDATE: '/user/updateProfile',
    GET_ALL: '/admin/user/list',
    UPDATE_INFO: '/admin/user/update',
    UPDATE_SUBSCRIPTION: '/admin/user/updateSubscription',
    UPDATE_CREDIT: '/admin/user/updateCredit',
    EXPORT_EXCEL: '/admin/user/export'
}

const USER_IMPORT = {
    GET_DEMO_FILE: '/admin/user/getImportFile',
    PUT_FILE: '/admin/user/importExcel',
    CREATE_USER: '/admin/user/createUser'
}

const PASSWORD = {
    FORGOT: '/user/forgot_password',
    RESET: BACKEND_API + '/user/reset_password',
    CHANGE: '/user/changePassword',
    ADMIN_RESET: '/admin/user/changePassword'
}

const TAG = {
    GET_TAG_ALL: '/tag',
    PUT_TAG: '/tag',
    UPDATE_TAG: '/tag/update/{id}',
    SHARE_TAG: '/tag/share/{id}',
    DENY_TAG: '/tag/deny/{id}',
    GET_TAG_INFO: '/tag/{id}',
    GET_ALL_TAG_BY_EMAIL: '/tag/user'
}

const GROUP = {
    GET_GROUP_ALL: '/group',
    PUT_GROUP: '/group/create',
    APPEND_DOCUMENT: '/group/append-doc',
    DELETE_DOCUMENT: '/group/delete-doc/{groupId}',
    UPDATE_GROUP: '/group/update/{id}',
    GET_GROUP_INFO: '/group/{id}',
    GET_GROUP_STATISTICS: '/group/statistic/{id}'
}


const TENANT = {
    GET_CONFIG: BACKEND_API + '/tenant/configs'
}

const KEY_API = {
    GET_ALL_APP: '/application/all-app',
    GET_APP: '/application/info/{id}',
    PUT_NEW_APP: '/application/new-app',
    DELETE: '/application/delete/{id}',
    REGENERATE: '/application/regenerate/{id}',
    UPDATE: '/application/update/{id}'
}

export {
    DOCUMENT,
    TAG,
    GROUP,
    GROUP_DOCUMENT,
    DOWNLOAD_DOCUMENT,
    DELETE_DOCUMENT,
    DELETE_GROUP,
    BACKEND_API,
    DOIT_CONFIG,
    USER_PROFILE,
    USER_AUTH,
    USER_INFO,
    PASSWORD,
    TENANT,
    USER_IMPORT,
    ADMIN_DASHBOARD,
    SYSTEM_CONFIG,
    DOWNLOAD_GROUP_DOCUMENT,
    DOCUMENT_VERSION,
    GROUP_DOCUMENT_VERSION,
    KEY_API
}

